import { render, staticRenderFns } from "./MainToDo.vue?vue&type=template&id=62822f54&scoped=true"
import script from "./MainToDo.vue?vue&type=script&lang=js"
export * from "./MainToDo.vue?vue&type=script&lang=js"
import style0 from "./MainToDo.vue?vue&type=style&index=0&id=62822f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62822f54",
  null
  
)

export default component.exports